import { useState, useEffect } from "react";
import { publicApi } from "@/services/api";
import logo from "../../../assets/logo.png";
export default function AppHeader() {
  const [phone, setPhone] = useState("000000000");

  useEffect(() => {
    publicApi
      .get("/settings/public")
      .then(({ data }: any) => {
        if (data.site_phone) setPhone(data.site_phone);
      })
      .catch(() => {});
  }, []);

  const formatted = phone.replace(/[^0-9]/g, "");

  return (
    <header
      className="sticky top-0 z-40 bg-white border-b-2 border-gray-900 px-4 py-3"
      dir="rtl"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center">
          <img src={logo} alt="לוגו" className="h-10 w-auto object-contain" />
        </div>
        <div className="flex items-center gap-3">
          {/* <a
            href={`tel:${formatted}`}
            className="w-11 h-11 flex items-center justify-center rounded-full border-2 border-gray-900 bg-white cursor-pointer hover:bg-gray-50 transition-colors whitespace-nowrap"
            aria-label="צור קשר"
          >
            <i className="ri-phone-line text-xl text-gray-800"></i>
          </a> */}
        </div>
      </div>
    </header>
  );
}
